import session from '@/auth/session'
import jwt from 'jsonwebtoken'

const getPayload = () => {
  const { payload = {} } = jwt.decode(session.getToken(), {complete: true}) || {}
  return payload
}

export const getUserSubscription = () => {
  const { data = {} } = getPayload()
  const { subscription = '' } = data
  return subscription
}

export const getPromoterCode = () => {
  let payload = getPayload()
  return payload.data.promEntityCode
}

export const getUsername = () => {
  let payload = getPayload()
  return payload.data.username
}
